await themeComponent(theme.components['mc-element'], false);
class McCard extends McElement{
    constructor(){
        super();
    }
    connectedCallback(){
        if(this.dataset.others){
            setTimeout(() => {this.others = document.querySelectorAll(this.dataset.others)});
        }
    }
    afterOpen = () => {
        if(this.references){
            this.references.forEach((reference) => {reference.activate()})
        }
        if(this.others){
            this.others.forEach(element => {
                if(element != this){
                    element.deactivate();
                }
            });
        }
    }
    afterClose = () => {
        if(this.references){
            this.references.forEach((reference) => {reference.deactivate()})
        }
    }
}

if(!window.customElements.get('mc-card')){
    window.customElements.define('mc-card', McCard);
}
window.McCard = McCard;